import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { loadAppDefinitions, reloadAppDefinitions, } from '../loadAppDefinitions';
var setupPromise;
export var setupM365AppsConfigService = function () {
    if (!setupPromise) {
        setupPromise = setupM365AppConfigServicePromise();
    }
    return setupPromise;
};
var setupM365AppConfigServicePromise = function () { return __awaiter(void 0, void 0, void 0, function () {
    var context;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                context = _a.sent();
                return [4 /*yield*/, ((context === null || context === void 0 ? void 0 : context.workload) == 'pwa' ||
                        (context === null || context === void 0 ? void 0 : context.workload) == 'officehomereact'
                        ? reloadAppDefinitions()
                        : loadAppDefinitions(true))];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//# sourceMappingURL=setupM365AppsConfigService.js.map